import DashboardLayout from "@/components/layout/DashboardLayout";
import Typography from "@/components/ui/typography";
import OpenPayoutsTable from "@/features/payouts/components/OpenPayoutsTable";
import PayoutHistoryTable from "@/features/payouts/components/PayoutHistoryTable";

const Payouts = () => {
  return (
    <DashboardLayout>
      <div className="space-y-6">
        <Typography size="h1">Payouts</Typography>
        <OpenPayoutsTable />
        <PayoutHistoryTable />
      </div>
    </DashboardLayout>
  );
};

export default Payouts;
